import { webAPI } from '../../../axiosInstance';


const getOneCategory = async (productId: any) => {
  const response = await webAPI.get(`/categories/${productId}`);
  return response.data;
};


const editCategory = async (data: any) => {
  console.log('dataeeee', data)
  const response = await webAPI.put(`/categories/edit/${data?.categoryId}`, data?.formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export { getOneCategory, editCategory };
